import React from "react";
import {useLocation} from "react-router-dom";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import {AuthPageLayout} from "../../components/AuthShell";
import AccountRecoveryLinks from "../../components/AuthShell/AccountRecoveryLinks";
import ResendVerificationForm from "./ResendVerificationForm";
import {
  BodyText,
  EmailAddress,
  Heading,
  IconTile,
  StatePanel,
} from "./styled";

export default function CheckYourEmail() {
  const location = useLocation();
  const email = location.state?.email || "";

  return (
    <AuthPageLayout testId="verify-email-check">
      <StatePanel>
        <IconTile aria-hidden="true"><MailOutlineRoundedIcon sx={{fontSize: 26}} /></IconTile>
        <Heading component="h1">Check your email</Heading>
        <BodyText>
          {email
            ? "We received your registration request. Check your inbox for a link to finish creating your account."
            : "Enter your email address below to request a verification link."}
        </BodyText>
        {email && <EmailAddress>{email}</EmailAddress>}
        <BodyText>
          Follow the verification link to set your password. Check your spam folder, or correct
          the address below and request another link if the message does not arrive.
        </BodyText>
        <ResendVerificationForm initialEmail={email} />
        <BodyText>Already have an account?</BodyText>
        <AccountRecoveryLinks />
      </StatePanel>
    </AuthPageLayout>
  );
}
